import { cn } from '@/lib/utils'
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react'
import React, { useState, type CSSProperties } from 'react'
import {
  AccordionItemLink,
  type AccordionItemLinkProps,
} from './accordion-item-link'

export type AccordionSectionProps = {
  badgeStyle?: CSSProperties
  chevronStyle?: CSSProperties
  className?: string
  contentClassName?: string
  count: number
  defaultOpen?: boolean
  headerStyle?: CSSProperties
  icon?: React.ReactNode
  id: string
  items: AccordionItemLinkProps[]
  style?: CSSProperties
  title: string
  titleStyle?: CSSProperties
}

export const AccordionSection = ({
  badgeStyle,
  chevronStyle,
  className,
  contentClassName,
  count,
  defaultOpen = false,
  headerStyle,
  icon,
  items,
  style,
  title,
  titleStyle,
}: AccordionSectionProps) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div
      className={cn('overflow-hidden rounded-[14px] border', className)}
      style={style}
    >
      <button
        type="button"
        onClick={() => setOpen(current => !current)}
        className="flex w-full cursor-pointer items-center justify-between gap-4 px-4 py-3 text-left"
        style={headerStyle}
      >
        <div className="flex min-w-0 items-center gap-2">
          {icon}
          <p
            className="min-w-0 text-[14px] font-semibold"
            style={titleStyle}
          >
            {title}
          </p>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <span
            className="inline-flex h-6 min-w-6 items-center justify-center rounded-full px-2 text-[11px] font-semibold"
            style={badgeStyle}
          >
            {count}
          </span>
          {open ? (
            <ChevronUpIcon className="size-4" style={chevronStyle} />
          ) : (
            <ChevronDownIcon className="size-4" style={chevronStyle} />
          )}
        </div>
      </button>

      {open && (
        <div className={cn('space-y-0 bg-white', contentClassName)}>
          {items.map(item => (
            <AccordionItemLink key={item.itemKey} {...item} />
          ))}
        </div>
      )}
    </div>
  )
}
